import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PHONE, PHONE_RAW, EMAILS, ADDRESS } from "@/lib/api";

export default function Footer({ onBook }) {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0B192C] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2 max-w-sm">
          <Logo light />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed">
            Vizag's only CMC Vellore-trained hematopathologist-led diagnostic center. Complete pathology, flagship hematopathology in 24-48 hours, digital radiology and home sample collection.
          </p>
          <button onClick={() => onBook([])} data-testid="footer-book-button"
            className="mt-6 bg-[#D92638] hover:bg-[#B81D2D] text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200 hover:-translate-y-0.5 active:scale-95">
            Book Appointment
          </button>
        </div>
        <div>
          <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-slate-500 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[["Services", "#services"], ["Tests & Prices", "#tests"], ["Packages", "#packages"], ["Why Hemozy", "#why"], ["For Hospitals", "#b2b"], ["FAQs", "#faq"]].map(([l, h]) => (
              <li key={h}><a href={h} onClick={(e) => go(e, h)} className="text-slate-300 hover:text-[#14B8A6] transition-colors">{l}</a></li>
            ))}
            <li><Link to="/reports" className="text-[#14B8A6] hover:text-white transition-colors font-medium" data-testid="footer-reports-link">Download My Report →</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-slate-500 mb-5">Contact</h4>
          <ul className="space-y-3.5 text-sm text-slate-300">
            <li className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-[#D92638] shrink-0" /><a href={`tel:${PHONE_RAW}`} className="hover:text-white transition-colors">{PHONE}</a></li>
            <li className="flex items-center gap-2.5"><MessageCircle className="w-4 h-4 text-[#14B8A6] shrink-0" /><a href={`https://wa.me/${PHONE_RAW}`} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp us</a></li>
            {EMAILS.map((em) => (
              <li key={em} className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-[#14B8A6] shrink-0" /><a href={`mailto:${em}`} className="hover:text-white transition-colors">{em}</a></li>
            ))}
            <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 text-[#D92638] shrink-0 mt-0.5" /><span>{ADDRESS}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Hemozy Diagnostics, Visakhapatnam. All rights reserved.</span>
          <Link to="/admin/login" className="hover:text-slate-300 transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
